import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getJson = (str) => {
  try {
    return !!str && JSON.parse(str);
  } catch (e) {
    return null;
  }
};
class NotificationService {
  constructor(notificationApiUrl, getCustomAccessToken) {
    this.getNotification = async (params) => {
      var _a;
      const paramsString = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== void 0 && value !== null) {
          if (key === "externalTypes" && Array.isArray(value)) {
            value.forEach((item) => {
              paramsString.append("externalTypes", item);
            });
          } else {
            paramsString.append(key, value);
          }
        }
      });
      const { data } = params.externalTypes ? await this.notificationApi.get(`/notifications?${paramsString.toString()}`) : await this.notificationApi.get(`/notifications`, {
        params: __spreadValues({}, params)
      });
      const formattedNotis = ((_a = data.data.notifications) == null ? void 0 : _a.map((noti) => {
        const parsedLink = getJson(noti.link);
        const parsedData = typeof noti.data === "string" ? getJson(noti.data) : noti.data;
        const link = parsedLink ? parsedLink : "";
        const notificationType = noti.type || link.type;
        const notificationData = parsedData || (link == null ? void 0 : link.data);
        if (notificationType && ["order", "noti"].includes(notificationType)) {
          return __spreadProps(__spreadValues({}, noti), {
            order: notificationType === "order" ? notificationData : null,
            deepLink: notificationType === "noti" ? notificationData == null ? void 0 : notificationData.deeplink : null
          });
        }
      }).filter((noti) => !!noti)) || [];
      return __spreadProps(__spreadValues({}, data.data), {
        notifications: formattedNotis
      });
    };
    this.markNotificationAsRead = async (notificationId, token) => {
      const { data } = await this.notificationApi.put(`/notification/${notificationId}/mark-read`, {
        token
      });
      return data;
    };
    this.unreadCount = async (params) => {
      const { data } = await this.notificationApi.get("/notification/count-unread", {
        params: __spreadValues({}, params)
      });
      return data == null ? void 0 : data.data;
    };
    this.registerToken = async (params) => {
      await this.notificationApi.post("notification/register-token", params);
    };
    this.unRegisterToken = async (params) => {
      await this.notificationApi.post("notification/unregister-token", params);
    };
    this.markReadAll = async (params) => {
      await this.notificationApi.put("notification/mark-read-all", params);
    };
    this.notificationApi = new Api(notificationApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.notificationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.notificationApi.addInterceptor(accessTokenInterceptor);
    }
  }
}

export { NotificationService };
